import { Card, Flex, Image } from "antd";
import Paragraph from "antd/es/typography/Paragraph";
import { memberType } from "../../../../types/member";
import { t } from "i18next";
import marketIcon from "../../../../assets/icons/market.svg";

type MemberDescriptionProps = {
  data: memberType;
  preview?: boolean;
};

const MemberDescription: React.FC<MemberDescriptionProps> = ({
  data,
  preview = false,
}: MemberDescriptionProps) => {
  if (!data.is_enabled_referral && !data.store && !data.clerk_name) {
    return null;
  }
  return (
    <Card
      bordered={false}
      styles={{
        body: { padding: 0 },
      }}
      className="p-[16px] rounded-[12px]"
    >
      <Flex gap={"8px"} align="center" className="w-full">
        <Image src={marketIcon} preview={false} />

        <Flex
          gap={"8px"}
          justify={(preview || (!data.store && !data.clerk_name))? "space-between" : "flex-start"}
          align="center"
          className="w-full"
        >
          <Paragraph className="body-medium text-o-body">
            {preview ? t("Agent") : data.store || t("Agent")}
          </Paragraph>
          <Paragraph className="note-regular text-o-body">
            {preview ? t("Please contact the agent") : data.clerk_name || t("Please contact the agent")}
          </Paragraph>
        </Flex>
      </Flex>
    </Card>
  );
};
export default MemberDescription;
